import { System, SystemImpl } from "minecs";
import type { GameModel } from "yage/game/GameModel";
import { Transform } from "yage/schemas/entity/Transform";
import { AirportState, AirportAgent, AirportStaff, AirportTrash } from "../components/index.js";
import { BINS, binPad, onPad } from "../domain/config.js";
import { addMoney } from "../domain/economy.js";
import { ids, state, career, distance, feedback } from "../services/world.js";
import { staffCarry } from "../domain/staff.js";
/** Carry litter to an actual bin. Captains earn the cleanup bonus; a hired cleaner bins litter for nothing. */
@System(AirportState)
export class AirportCleanup extends SystemImpl<GameModel> {
    static depth = 4630;
    run = (g: GameModel) => {
        const e = state(g);
        if (!e.loaded) return;
        for (const id of ids(g, AirportAgent)) {
            const p = g.getTypedUnsafe(Transform, id), a = g.getTypedUnsafe(AirportAgent, id);
            if (a.inputLocked) continue;
            let carried = ids(g, AirportTrash).filter(t => g.getTypedUnsafe(AirportTrash, t).carrier === id);
            if (carried.length && BINS.some(b => onPad('trash', p, binPad(b)))) {
                const count = carried.length;
                for (const t of carried) g.removeEntity(t);
                e.trashDisposed += count;
                const amount = addMoney(career(g), e, count * 4);
                feedback(g, id, `Disposed of ${count} litter · +${amount} cleanup bonus`);
                e.revision++; carried = [];
            }
            let count = carried.length;
            for (const t of ids(g, AirportTrash)) {
                const trash = g.getTypedUnsafe(AirportTrash, t);
                if (trash.carrier < 0 && count < 4 + e.trashLevel * 2 && distance(p, g.getTypedUnsafe(Transform, t)) < 36) {
                    trash.carrier = id; count++;
                    if (count === 4 + e.trashLevel * 2) feedback(g, id, 'Trash stack full. Carry it to a green bin.');
                }
            }
        }
        for (const id of ids(g, AirportStaff)) {
            const cleaner = g.getTypedUnsafe(AirportStaff, id);
            if (cleaner.role !== 'cleaner') continue;
            const carry = staffCarry(cleaner.recordId, 'litter');
            const p = g.getTypedUnsafe(Transform, id);
            const carried = ids(g, AirportTrash).filter(t => g.getTypedUnsafe(AirportTrash, t).carrier === id);
            if (carried.length && BINS.some(b => onPad('trash', p, binPad(b)))) { for (const t of carried) g.removeEntity(t); e.revision++; continue; }
            let count = carried.length;
            for (const t of ids(g, AirportTrash)) {
                const trash = g.getTypedUnsafe(AirportTrash, t);
                if (count < carry && trash.carrier < 0 && distance(p, g.getTypedUnsafe(Transform, t)) < 36) { trash.carrier = id; count++; }
            }
        }
        for (const id of ids(g, AirportTrash)) {
            const t = g.getTypedUnsafe(AirportTrash, id);
            if (t.carrier < 0) continue;
            if (!g.isActive(t.carrier)) { t.carrier = -1; continue; }
            const p = g.getTypedUnsafe(Transform, t.carrier);
            Object.assign(g.getTypedUnsafe(Transform, id), { x: p.x, y: p.y });
        }
    };
}
